import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import URI from "URI/URI";
import markup from "ulysses/widgets/dashboard/editing.html";
import indicator_api from "ulysses/widgets/indicators/indicator";
import static_api from "ulysses/widgets/static_html";
import chart_api from "ulysses/widgets/charts/chart";
import indicatorlist_api from "ulysses/widgets/indicators/indicator_list";
import actionbutton_api from "ulysses/widgets/action_button/action";
import custom_widget_api from "ulysses/widgets/dashboard/custom_widget";

"use strict";
$(document).ready(function() { $(markup).appendTo($("body")); });

var css_classes = {
    "1": "col col-xs-12",
    "2": "col col-xs-12 col-sm-6",
    "3": "col col-xs-12 col-sm-4",
    "4": "col col-xs-12 col-sm-6 col-md-3",
    "6": "col col-xs-12 col-sm-6 col-md-4 col-lg-4 col-vlg-2"
};

var derived_classes = {
    "2": {
        "2": "col col-xs-12"
    },
    "3": {
        "2": "col col-xs-12 col-sm-8",
        "3": "col col-xs-12"
    },
    "4": {
        "2": "col col-xs-12 col-sm-6 col-md-6",
        "3": "col col-xs-12 col-sm-6 col-md-9",
        "4": "col col-xs-12"
    },
    "6": {
        "2": "col col-xs-12 col-sm-6 col-md-4 col-lg-4 col-vlg-4",
        "3": "col col-xs-12 col-sm-6",
        "4": "col col-xs-12 col-sm-6 col-md-8",
        "5": "col col-xs-12 col-sm-6 col-md-8 col-vlg-10",
        "6": "col col-xs-12"
    }
}

var widget_selectors = {
    "indicatorlist": function(cdata) {
        return indicatorlist_api.select_indicator_list(cdata ? cdata.settings : {}).then(function(result) {
            return {
                "settings": result,
                "class": "indicatorlist",
                "columns": (result && result.columns) ? result.columns : 1
            };
        });
    },
    "indicators": function(cdata) {
        return indicator_api.select_indicator(cdata ? cdata.settings : {}).then(function([result, extra_info]) {
            console.log("Indic got result: ", result);
            return {
                "settings": result,
                "class": "indicators",
                "caption": ko.unwrap(result.caption) || extra_info.caption,
                "icon": extra_info.icon,
                "colour": extra_info.colour,
                "columns": (result && result.columns) ? result.columns : 1
            };
        });
    },
    "static": function(cdata) {
        return static_api.configure_html(cdata ? cdata.settings : {}).then(function(result) {
            console.log("Static got result:", result);
            return {
                "settings": result,
                "class": "static",
                "columns": (result && result.columns) ? result.columns : 1
            };
        });
    },
    "chart": function(cdata) {
        return chart_api.select_chart(cdata ? cdata.settings: {}).then(function(result) {
            return {
                "settings": result,
                "class": "chart",
                "columns": (result && result.columns) ? result.columns : 1
            };
        });
    },
    "actionbutton": function(cdata) {
        return actionbutton_api.configure_action(cdata? cdata.settings: {}).then(function(result) {
            return {
                "settings": result,
                "class": "actionbutton",
                "columns": (result && result.columns) ? result.columns : 1
            }
        })
    },
    "custom": function(cdata) {
        console.log("Editing custom:", cdata);
        return custom_widget_api.select_widget(cdata ? cdata.settings : {}).then(function([result, extra_info]) {
            console.log("Custom got result:", result);
            return {
                "settings": result,
                "class": "custom",
                "caption": extra_info.caption,
                "colour": extra_info.colour,
                "icon": extra_info.icon,
                "columns": (result && result.columns) ? result.columns : 1
            };
        });
    }
};

function new_row(cols, is_growable, settings) {
    var row = [];
    for (var i=0;i<cols;++i) {
        row.push({"caption":null, "settings":null, colour:null,icon:null});
    }
    return create_editable_row({ "cells": row, "css_class":css_classes[cols], "cols": cols, "is_growable": is_growable }, settings);
}

function create_editable_row(row, settings) {
    if (!row || row.length == 0)
        return null;

    var cells = [];
    var is_growable = row.is_growable;
    if (row.cells) {
        row = row.cells;
    }
    cells = row.map((val) => {
        if (val.class == "indicator")
            val.class = "indicators";
        var widget_def = val && (uly.widgets.get_registered()[val.class] || val.class == "custom");
        if (widget_def) {
            console.log("Got widget def:", widget_def);
            return ko.observable({
                "class": val.class,
                "caption": val.settings.caption || val.caption || widget_def.caption,
                "icon": val.icon || widget_def.icon,
                "colour": val.colour || widget_def.colour,
                "settings": val.settings,
                "columns": val.columns || 1
            });
        } else {
            return ko.observable(null);
        }
    });

    var new_row = {
        "cells": cells,
        "cols": cells.length,
        "css_class":css_classes[cells.length],
        "is_growable": is_growable

    };
    new_row.edit_widget = function edit_widget(widget, ev) {
        var cell = new_row.cells.filter(function(c) { return c() == widget; })[0];
        if (cell) {
            return widget_selectors[widget["class"] || "indicators"](cell()).then(function(result) {
                cell(result);
            });
        }
    };
    new_row.remove_row = function remove_row(widget, ev) {
        var rows = settings.rows();
        rows.splice(rows.indexOf(new_row), 1);
        settings.rows(rows);
    };
    new_row.remove_widget = function remove_widget(widget, ev) {
        var cell = new_row.cells.filter(function(c) { return c() == widget; })[0];
        if (cell) {
            cell(null);
        }
    };
    new_row.move_widget_up = function move_up(widget, ev) {
        console.log("widget:", widget, "arguments:", arguments);
        var wobs = new_row.cells.filter((v,idx) => v() == widget)[0];
        if (!wobs) {
            return;
        }

        var idx = new_row.cells.indexOf(wobs);
        if (idx > 0) {
            var ow = new_row.cells[idx-1]();
            new_row.cells[idx-1](wobs());
            new_row.cells[idx](ow);
        }
    }
    new_row.move_widget_down = function move_up(widget, ev) {
        console.log("widget:", widget, "arguments:", arguments);
        var wobs = new_row.cells.filter((v,idx) => v() == widget)[0];
        if (!wobs) {
            return;
        }

        var idx = new_row.cells.indexOf(wobs);
        if (idx < new_row.cells.length - 1) {
            var ow = new_row.cells[idx+1]();
            new_row.cells[idx+1](wobs());
            new_row.cells[idx](ow);
        }
    }
    new_row.move_up = function move_up(widget, ev) {
        var rows = settings.rows();
        var idx = rows.indexOf(new_row);
        console.log("Move up:", idx, ko.toJS(rows));
        if (idx > 0) {
            var moving_rows = rows.splice(idx, 1);
            console.log("moving: ", moving_rows);
            rows.splice(idx - 1, 0, new_row);
            console.log("Moved up:", ko.toJS(rows));
        }
        settings.rows(rows);
    }
    new_row.move_down = function move_up(widget, ev) {
        var rows = settings.rows();
        var idx = rows.indexOf(new_row);
        console.log("Move dwn:", idx, rows);
        if (idx < rows.length - 1) {
            rows.splice(idx, 1);
            rows.splice(idx + 1, 0, new_row);
        }
        settings.rows(rows);
    }
    new_row.get_css_class = function get_css_class(cell) {

        var columns = (cell && cell.columns) || 1;
        var row_length = ko.unwrap(new_row.cells).reduce((acc, c) => { return 1*acc + 1*(ko.unwrap((ko.unwrap(c) || {}).columns) || 1); }, 0);

        if (row_length < 1) { row_length = 1; }
        else if (row_length >= 5) { row_length = 6; }

        var base_css = css_classes[row_length];
        console.log("columns:", columns, "row_length:", row_length, "base_css:", base_css);

        if (columns <= 1 || columns > 6) {
            return base_css;
        }
        if (row_length == 1) {
            return base_css;
        }

        var css = derived_classes[row_length][columns];
        return css || base_css;
    }

    return new_row;

}

function configure_dashboard(current_settings) {
    var settings = {};
    $.extend(settings, {
        "title": ko.observable(current_settings.title),
        "path": ko.observable(current_settings.path),
        "filter": ko.observable(current_settings.filter),
        "show_header": ko.observable(typeof current_settings.show_header === "undefined" ? true : current_settings.show_header),
        "activate_first": ko.observable(current_settings.activate_first || false),
        "tabs": ko.observableArray([]),
        "active_tab": ko.observable(null),
        "rows": ko.pureComputed(() => ko.unwrap((ko.unwrap(settings.active_tab) || {}).rows) ),
        "add_row": function() {
            uly.dialogs.execute($("#dashboard-select-row-layout-tmpl").html(), {"title": _("dashboard_title_new_row", "New Row")}, {"cols":4, "is_growable": false})
               .then(function([result]) {
                var row = new_row(ko.unwrap(result.cols), ko.unwrap(result.is_growable), settings);
                settings.active_tab().rows.push(row);
            });
        },
        "add_tab": () => {
            var new_tab = {
                "caption": ko.observable(null),
                "icon": ko.observable(null),
                "rows": ko.observableArray([])
            };
            new_tab.activate = () => { settings.active_tab(new_tab); };
            settings.tabs.push(new_tab);
            new_tab.activate();
        },
        "delete_row": function(row) {
            settings.active_tab().rows.splice(row, 1);
        },
        "delete_tab": function() {
            var tab = settings.active_tab();
            var idx = settings.tabs.indexOf(tab);
            settings.tabs.splice(idx, 1);
            if (idx > 9) {
                settings.active_tab(settings.tabs()[idx - 1]);
            } else {
                settings.active_tab(settings.tabs()[0]);
            }
        },
        "select_widget": function(row_index, cell_index, target_class) {
            console.log("row_index:", row_index, "cell_index:", cell_index, "rows:", settings.rows());
            var row = settings.rows()[row_index];
            if(row) {
                var cell = row.cells[cell_index];
                target_class = target_class || "indicators";
                return widget_selectors[target_class](cell()).then(function(result) {
                    cell(result);
                });
            }
        }
    });
    Object.assign(settings, {
        can_move_left: ko.pureComputed(() => settings.tabs.indexOf(settings.active_tab()) > 0),
        can_move_right: ko.pureComputed(() => settings.tabs.indexOf(settings.active_tab()) < settings.tabs().length - 1),
        move_tab_left: () => {
            let t = settings.active_tab();
            let idx = settings.tabs.indexOf(t);
            if (idx > 0) {
                settings.tabs.splice(idx, 1);
                settings.tabs.splice(idx - 1, 0, t);
            }
        },
        move_tab_right: () => {
            let t = settings.active_tab();
            let idx = settings.tabs.indexOf(t);
            if (idx < settings.tabs().length - 1) {
                settings.tabs.splice(idx, 1);
                settings.tabs.splice(idx + 1, 0, t);
            }
        }
    });
    
    var tabs = [];
    if (current_settings.tabs) {
        tabs = current_settings.tabs;
    } else if (current_settings.rows) {
        tabs = [{ "caption": "", "rows": current_settings.rows }];
    }

    tabs = tabs.map((tab) => {
        var rows = [];
        if (tab.rows) {
            rows = tab.rows.map((row) => create_editable_row(row, settings) ).filter((v) => v);
        }
        var new_tab = {
            "caption": ko.observable(tab.caption),
            "icon": ko.observable(tab.icon),
            "rows": ko.observableArray(rows)
        }
        new_tab.activate = () => { settings.active_tab(new_tab); };
        return new_tab;
    });

    settings.tabs(tabs);
    if (tabs.length > 0) {
        settings.active_tab(tabs[0]);
    }

    console.log("got settings:", settings);
    return uly.dialogs.execute($("#dashboard-editor-tmpl").html() , {
        "title":_("dashboard_title_configure_dashboard", "Configure Dashboard"),
        "raw_data": true
    }, settings).then(function([result]) {
        var res = ko.toJS(result);
        console.log("got res:", res);
        return {
            "title":res.title,
            "path":res.path,
            "filter":res.filter,
            "show_header": res.show_header,
            "activate_first": res.activate_first,
            "tabs": res.tabs.map((tab) => {
                return {
                    "caption": ko.unwrap(tab.caption),
                    "icon": ko.unwrap(tab.icon),
                    "rows": (ko.unwrap(tab.rows) || []).map((row) => {

                        return {
                            "is_growable": row.is_growable || false,
                            "cells": row.cells.map(function(col) {
                                return Object.assign({}, col);//{ "class": col.class, "settings": col.settings };
                            })
                        };
                    })
                }
            })
        };
    });
}


export default configure_dashboard;
